import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  ViewChild,
} from "@angular/core";
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: "cookie-bar",
  template: `
    <div *ngIf="show" #cookieBar class="cookie-bar">
      <icon set="lucide" name="cookie" size="36" />
      <p
        class="cookie-bar-text"
        [innerHTML]="'GLOBAL.COOKIE_BAR.MESSAGE' | translate"
      ></p>
      <button class="button btn-primary cookie-bar-button" (click)="agree()">
        {{ "GLOBAL.COOKIE_BAR.PROCEED_BUTTON" | translate }}
      </button>
    </div>
  `,
  styleUrls: ["./cookie-bar.component.scss"],
})
export class CookieBarComponent implements AfterViewInit, OnDestroy {
  private cookieName = "cyber-skiller-cookie-permit";
  private resizeObserver?: ResizeObserver;

  @ViewChild("cookieBar") cookieBar?: ElementRef<HTMLDivElement>;

  show = false;

  constructor(private cookieService: CookieService) {
    this.show = !this.cookieService.check(this.cookieName);

    if (!this.show) {
      this.setCookieBarOffset(0);
    }
  }

  ngAfterViewInit(): void {
    if (!this.show || !this.cookieBar?.nativeElement) {
      this.setCookieBarOffset(0);
      return;
    }

    this.updateCookieBarOffset();
    this.resizeObserver = new ResizeObserver(() =>
      this.updateCookieBarOffset(),
    );
    this.resizeObserver.observe(this.cookieBar.nativeElement);
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
    this.setCookieBarOffset(0);
  }

  agree() {
    this.cookieService.set(
      this.cookieName,
      "agree",
      730,
      "/",
      undefined,
      undefined,
      "Strict",
    );
    this.show = false;
    this.resizeObserver?.disconnect();
    this.setCookieBarOffset(0);
  }

  private updateCookieBarOffset(): void {
    this.setCookieBarOffset(this.cookieBar?.nativeElement.offsetHeight ?? 0);
  }

  private setCookieBarOffset(height: number): void {
    document.documentElement.style.setProperty(
      "--cookie-bar-offset",
      `${height}px`,
    );
  }
}
